import { useCallback, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useUnmount } from "app/custom-hooks/useUnmount";
import { selectFiltersValue } from "app/pages/sales-intelligence/modules/leads-search-filters";

import { setIsRowSelectionEnabled, setSelectedRows } from "../store/action-creators";
import { selectSearchText } from "../store/selectors";

export const useClearAndCloseRowsSelection = (): VoidFunction => {
    const dispatch = useDispatch();

    const searchText = useSelector(selectSearchText);
    const filtersValue = useSelector(selectFiltersValue);

    const clearAndCloseRowsSelection = useCallback((): void => {
        dispatch(setIsRowSelectionEnabled(false));
        dispatch(setSelectedRows([]));
    }, []);

    useEffect(() => {
        dispatch(setSelectedRows([]));
    }, [searchText, filtersValue]);

    useUnmount(() => {
        clearAndCloseRowsSelection();
    });

    return clearAndCloseRowsSelection;
};
